module.exports = __webpack_public_path__ + "static/netlify-01-bcb6f2a4c458fd1b6663df47bbe07c0e.png";